var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',_vm._l((_vm.groupedSettings),function(settingsGroup,groupName){return _c('v-row',{key:groupName,staticClass:"mb-6"},[_c('v-col',{staticClass:"pa-0",attrs:{"cols":"12"}},[_c('SettingsManager',{attrs:{"group-name":groupName,"group-settings":settingsGroup},on:{"setting-updated":_vm.fetchSettings}})],1)],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }